import React from 'react';

export interface GuardarIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const GuardarIcon: React.FC<GuardarIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m20.255 22.745-7.291-5.208-7.292 5.208V6.078a2.083 2.083 0 0 1 2.083-2.083h10.417a2.083 2.083 0 0 1 2.083 2.083z"/>
    </svg>
  );
};

export default GuardarIcon;
